export * from '@primeuix/themes/material/splitter';
export { default } from '@primeuix/themes/material/splitter';
